/**
 * Identity verification (KYC) as the account page shows it, boxed parity (`AccountVerification`'s
 * `statusMap`): Veriff's nine statuses fold into four states, and an approval that failed the
 * platform's policy (`kycStatus === "approved"` but not `kycVerified`) reads as denied.
 */
import type { EndUser, KycStatus } from "@loot-os/client";

export type KycUiState = "canStart" | "processing" | "approved" | "declined";

const STATE_BY_STATUS: Record<KycStatus, KycUiState> = {
  created: "canStart",
  started: "canStart",
  submitted: "processing",
  review: "processing",
  approved: "approved",
  declined: "declined",
  resubmission_requested: "canStart",
  expired: "canStart",
  abandoned: "canStart",
};

export function kycUiState(user: Pick<EndUser, "kycStatus" | "kycVerified"> | null): KycUiState {
  if (!user?.kycStatus) return "canStart";
  if (user.kycStatus === "approved" && !user.kycVerified) return "declined";
  return STATE_BY_STATUS[user.kycStatus];
}
